import React from 'react';
import './PracticeSummaryInfoPage.scss';
import { contentData, contentDataType } from './PracticeSummaryConstant';
import lineImage from '../../../../../../assets/icons/VerticalDivider.png';
import { useTranslation } from 'react-i18next';

const PracticeSummaryInfoPage: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="practice-summary-info-page">
      <div className="practice-summary-info-page__header-content">
        <div className="practice-summary-info-page__header-content__title">
          {isMobile
            ? t('practiceSummaryInfoPage.practiceSummaryHeaderMobile')
            : t('practiceSummaryInfoPage.practiceSummaryHeader')}
        </div>
        <div className="practice-summary-info-page__header-content__description">
          {t('practiceSummaryInfoPage.practiceSummaryDescription')}
        </div>
      </div>
      <div className="practice-summary-info-page__content">
        {contentData &&
          contentData?.length > 0 &&
          contentData.map((item: contentDataType, index: number) => (
            <div
              className="practice-summary-info-page__content__item"
              key={index}
            >
              <div className="practice-summary-info-page__content__item__grid">
                <div className="practice-summary-info-page__content__item__grid__icon">
                  <div className="practice-summary-info-page__content__item__grid__icon__circle">
                    <img src={item?.img} alt={`${item?.title}-icon`} />
                  </div>
                  {item?.isLineImage && !isMobile && (
                    <div className="practice-summary-info-page__content__item__grid__icon__line-image">
                      <img src={lineImage} alt="line-icon" />
                    </div>
                  )}
                </div>
                {isMobile ? (
                  <div className="practice-summary-info-page__content__item__grid__content">
                    <div className="practice-summary-info-page__content__item__grid__content__title">
                      <div className="practice-summary-info-page__content__item__grid__content__title__text">
                        <div className="practice-summary-info-page__content__item__grid__content__title__text__title">
                          {item?.title}
                        </div>
                        <div className="practice-summary-info-page__content__item__grid__content__title__text__time">
                          {item?.time}
                        </div>
                      </div>
                      <div className="practice-summary-info-page__content__item__grid__content__title__description">
                        {item?.description}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="practice-summary-info-page__content__item__grid__content">
                    <div className="practice-summary-info-page__content__item__grid__content__title">
                      <div className="practice-summary-info-page__content__item__grid__content__title__text">
                        {item?.title}
                      </div>
                      <div className="practice-summary-info-page__content__item__grid__content__title__description">
                        {item?.description}
                      </div>
                    </div>
                    <div className="practice-summary-info-page__content__item__grid__content__time">
                      {item?.time}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
      <div className="practice-summary-info-page__footer-content">
        {t('practiceSummaryInfoPage.practiceSummaryFooter')}
      </div>
    </div>
  );
};

export default PracticeSummaryInfoPage;
